/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 2, height = 28 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 2 18" fill="none">
    <path d="M1 1L0.999999 17" stroke="#E8DFD7" strokeLinecap="round"/>
  </svg>
);

export default SvgComponent;
